<app-unauth-main-layout
  [desktopVideoUrl]="desktopBackgroundVideo"
  [tabletVideoUrl]="tabletBackgroundVideo"
  [mobileVideoUrl]="mobileBackgroundVideo"
  ><div class="content-wrapper">
    <div [innerHTML]="title | safeHtml"></div>
    <form [formGroup]="formGroup" class="form-wrapper">
      <div class="mb-3 col-11 col-sm-12 d-flex flex-column align-items-start">
        <label class="fw-bold">Email</label>
        <input class="form-control" type="email" formControlName="email" autocomplete="off" />
      </div>
      <div class="mb-3 col-11 col-sm-12 d-flex flex-column align-items-start">
        <label class="fw-bold">Password</label>
        <input class="form-control" type="password" formControlName="password" autocomplete="off" />
      </div>
    </form>
    <div class="mt-3 d-flex flex-column align-items-start">
      <button type="submit" class="btn btn-primary btn-round btn-login" (click)="onSubmit()">Login</button>
      <button
        *ngIf="mode === 'admin'"
        class="btn btn-primary btn-round mt-4"
        type="button"
        (click)="signInWithGoogle()"
      >
        Login with Google
      </button>
      <a class="mt-3" routerLink="/auth/forgot-password" class="forgot-password-link">Forgot Password</a>
    </div>
  </div>
</app-unauth-main-layout>
